import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, getGlassStyle, neonMd } from './neonUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Modal', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-content`]: {
        ...getGlassStyle('heavy'),
        borderRadius: 4,
        border: `1px solid ${cyan[500]}25`,
        boxShadow: `${neonMd}, 0 25px 50px rgba(0,0,0,0.5)`,
        // Keep content padding at 0; spacing is centralized in `global.less`.
        padding: 0,
        overflow: 'hidden',
        position: 'relative' as const,

        // 顶部荧光线
        '&:before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 1,
          background: `linear-gradient(90deg, transparent, ${cyan[500]}80, transparent)`,
          pointerEvents: 'none',
        },
      },

      [`${componentCls}-header`]: {
        background: 'transparent !important',
        borderBottom: `1px solid ${cyan[500]}15`,

        [`${componentCls}-title`]: {
          color: `${cyan[200]} !important`,
          fontWeight: 600,
          letterSpacing: '0.5px',
        },
      },

      [`${componentCls}-body`]: {
        background: 'transparent',
      },

      [`${componentCls}-footer`]: {
        background: 'transparent !important',
        borderTop: `1px solid ${cyan[500]}15`,
      },

      // 关闭按钮
      [`${componentCls}-close`]: {
        color: `${cyan[600]} !important`,
        '&:hover': {
          color: `${cyan[400]} !important`,
        },
      },
    },
  }
})
